import classNames from 'classnames';
import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import useGetNamedColor from '../../common/useGetNamedColor';
import DropdownSelector from '../../components/actions/DropdownSelector';
import UserTag from '../../components/UserTag';
import useActualityAggregationFieldDescriptors from '../hooks/useActualityAggregationFieldDescriptors';
import { ActualityAggregationField } from '../store/actuality.kpi.types';

export type ActualityAggregateByGroupSelectorProps = {
  title?: string;
  value: ActualityAggregationField;
  onChange: (v: ActualityAggregationField) => void;
  className?: string;
};

const ActualityAggregateByGroupSelector: React.FC<
  ActualityAggregateByGroupSelectorProps
> = props => {
  const { t } = useTranslation('feed');
  const aggFieldsDescriptors = useActualityAggregationFieldDescriptors();
  const getNamedColor = useGetNamedColor();

  return (
    <DropdownSelector
      data-component="actuality-aggregate-by-group-selector"
      label={props.title}
      className={classNames(' w-full text-xs flex-1', props.className)}
      // classNameLabel='text-menu-text'
      value={props.value}
      values={_.map(aggFieldsDescriptors, d => d.field)}
      renderValueSelected={field => aggFieldsDescriptors[field]?.title ?? field}
      renderValue={(field, filter) => {
        const desc = aggFieldsDescriptors[field];
        const title = desc?.title ?? field;
        return (
          <>
            <span>{title}</span>
            <span className='flex flex-wrap items-center gap-1 max-w-10'>
              {_.map(desc?.tags, tag => (
                  <UserTag
                      key={tag}
                      title={tag}
                      actionable={false}
                  enabled={false}
                  className='text-xxs'
                      noColor
                    />
            ))}

            </span>
      
          </>
        );
      }}
      // valuePrimary
      // light
      // widthFull
      panelMode
      w_xl
      onChange={v => setTimeout(() => props.onChange(v), 10)}
      hasSearch
      filterValue={(field, filter) => {
        const descriptor = aggFieldsDescriptors[field];
        return (
          _.isEmpty(filter) ||
          _.some(
            [descriptor?.title, ...(descriptor?.tags ?? [])],
            t => t.toLowerCase().indexOf(filter.toLowerCase()) >= 0,
          )
        );
      }}
    />
  );
};
export default ActualityAggregateByGroupSelector;
